module.exports = __webpack_public_path__ + "img/ico-uk_BIG.645c7f7f.png";